// extracted by mini-css-extract-plugin
export var box = "Checkbox-module--box--68f1d";
export var checkboxWrapper = "Checkbox-module--checkboxWrapper--d04d7";
export var input = "Checkbox-module--input--e0b3e";
export var inputWrapper = "Checkbox-module--inputWrapper--3d024";
export var label = "Checkbox-module--label--ca26e";
export var outline = "Checkbox-module--outline--64e92";